<div class="background" *ngIf="profile">
  <div class="inset">
    <h1>{{ profile?.firstname }} {{ profile?.lastname }}</h1>
    <div class="horizontalLine"></div>
    <div *ngIf="!!profile?.uid">
      <div class="between">
        <div style="max-width: 150px">
          <h3>Your Information</h3>
        </div>
        <button
          *ngIf="!changingEmail"
          mat-stroked-button
          (click)="toggleChangingEmail()"
        >
          Change Email
        </button>
        <button
          *ngIf="changingEmail"
          mat-stroked-button
          (click)="onEmailSave()"
        >
          {{ newEmail != "" ? "Save" : "Cancel" }}
        </button>
      </div>
      <div *ngIf="!editing">
        <mat-form-field mat-error *ngIf="!changingEmail">
          <mat-label>First Name</mat-label>
          <input
            disabled="!editing"
            matInput
            id="name"
            class="short"
            name="name"
            type="text"
            [ngModel]="profile.firstname"
          />
        </mat-form-field>
        <br />
        <mat-form-field mat-error *ngIf="!changingEmail">
          <mat-label>Last Name</mat-label>
          <input
            disabled="!editing"
            matInput
            id="name"
            class="short"
            name="name"
            type="text"
            [ngModel]="profile.lastname"
          />
        </mat-form-field>
        <br />
        <mat-form-field *ngIf="!changingEmail">
          <input
            disabled="true"
            matInput
            id="code"
            class="short"
            name="email"
            type="email"
            placeholder="Email"
            [ngModel]="profile.email"
          />
        </mat-form-field>
        <br />
        <mat-form-field *ngIf="changingEmail">
          <input
            matInput
            id="code2"
            class="short"
            name="email"
            type="email"
            placeholder="New Email"
            [(ngModel)]="newEmail"
          />
        </mat-form-field>
        <br />
        <mat-form-field *ngIf="changingEmail">
          <input
            matInput
            id="code3"
            class="short"
            name="email"
            type="email"
            placeholder="Confirm Email"
            [(ngModel)]="confirmedEmail"
          />
        </mat-form-field>
        <br />

        <mat-form-field *ngIf="!changingEmail">
          <input
            disabled="!editing"
            matInput
            id="si-city"
            class="short"
            name="city"
            type="text"
            placeholder="City"
            [ngModel]="profile.city"
          />
        </mat-form-field>
        <br />

        <mat-form-field *ngIf="!changingEmail">
          <input
            disabled="!editing"
            matInput
            id="si-city"
            class="short"
            name="zip"
            type="text"
            placeholder="Zip"
            [ngModel]="profile.zipcode"
          />
        </mat-form-field>
        <br />
        <select
          *ngIf="!changingEmail"
          disabled="true"
          name="country"
          id="country"
          [(ngModel)]="profile.country"
        >
          <option *ngFor="let c of countries" value="{{ c.name }}">
            {{ c.name }}
          </option></select
        ><br />
      </div>
      <div *ngIf="!!editing">
        <mat-form-field mat-error>
          <mat-label>First Name</mat-label>
          <input
            matInput
            id="name"
            class="short"
            name="name"
            type="text"
            [(ngModel)]="profile.firstname"
          />
        </mat-form-field>
        <br />
        <mat-form-field mat-error>
          <mat-label>Last Name</mat-label>
          <input
            matInput
            id="name"
            class="short"
            name="name"
            type="text"
            [(ngModel)]="profile.lastname"
          />
        </mat-form-field>
        <br />

        <mat-form-field>
          <input
            matInput
            id="code"
            class="short"
            name="email"
            type="email"
            placeholder="Email"
            [(ngModel)]="profile.email"
          />
        </mat-form-field>
        <br />
        <mat-form-field>
          <input
            matInput
            id="si-city"
            class="short"
            name="city"
            type="text"
            placeholder="City"
            [(ngModel)]="profile.city"
          />
        </mat-form-field>
        <br />
        <mat-form-field>
          <input
            matInput
            id="si-city"
            class="short"
            name="zip"
            type="text"
            placeholder="Zip"
            [(ngModel)]="profile.zipcode"
          />
        </mat-form-field>
        <br />
        <select name="country" id="country" [(ngModel)]="profile.country">
          <option *ngFor="let c of countries" value="{{ c.name }}">
            {{ c.name }}
          </option></select
        ><br />
      </div>
    </div>
    <br />
    <br />
    <div class="horizontalLine"></div>
    <div class="between">
      <div style="max-width: 200px">
        <h3>Preferences</h3>
      </div>
    </div>

    <div
      class="between"
      aria-label="Controls notifications sent to your email."
    >
      <p>Email Notifications</p>
      <mat-slide-toggle
        [checked]="profile?.preferences?.notifications?.emailsEnabled"
        (toggleChange)="onToggle()"
      ></mat-slide-toggle>
    </div>
  </div>
</div>
